<template>
  <div
    class="am-profile-photo"
    style="cursor: pointer;"
  >
    <VDropdown
      v-if="photo && preview"
      :distance="6"
      :triggers="['hover']"
      placement="right-end"
    >
      <b-avatar
        variant="light-primary"
        :size="size"
        :src="profilePhoto"
        style="background-color: transparent !important;"
      />
      <template #popper>
        <div style="height: 300px;width: 250px;">
          <img
            style="object-fit: cover;"
            height="300px"
            width="250px"
            :src="profilePhoto"
          >
        </div>
      </template>
    </VDropdown>
    <b-avatar
      v-else
      variant="light-primary"
      :size="size"
      :src="profilePhoto"
      style="background-color: transparent !important;"
    >
      <feather-icon
        v-if="!profilePhoto && defaultLogo"
        :icon="defaultLogo"
      />
    </b-avatar>
  </div>
</template>

<script>
import { BAvatar, BTooltip, BCard } from 'bootstrap-vue'

export default {
  name: 'AmProfilePhoto',
  components: {
    BAvatar,
    BTooltip,
    BCard,
  },
  props: {
    photo: { type: String, default: null },
    size: { type: String | Number, default: '40' },
    defaultLogo: { type: String, default: null },
    preview: { type: Boolean, default: true },
  },
  computed: {
    profilePhoto() {
      if (!this.photo) {
        return null
      }
      return `${process.env.VUE_APP_STORAGE_PATH}/${this.photo}`
    },
  },
}
</script>

<style scoped>

</style>
